export const adminWebsocketCommands = {
    //route (commands)
    ADMIN_USER_SETTINGS_SET: 'setUserSettings',
    ADMIN_USER_PROFILE_SET: 'setUserProfile',
    //receive
    ADMIN_ROLES_ACCEPTED: 'ADMIN_ROLES_ACCEPTED',
    ADMIN_ROLES_ERROR: 'ADMIN_ROLES_ERROR',
};
